var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ws-backdrop",class:{ active: _vm.active }},[_c('div',{staticClass:"ws-backdrop-bg",on:{"click":_vm.backdropClicked}}),_vm._t("default",null,null,_vm.$attrs)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }